import { render } from "./WenAnListView.vue?vue&type=template&id=136fe9c4"
import script from "./WenAnListView.vue?vue&type=script&lang=js"
export * from "./WenAnListView.vue?vue&type=script&lang=js"

import "./WenAnListView.vue?vue&type=style&index=0&id=136fe9c4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__